module.exports = __webpack_public_path__ + "static/img/掌上智优_0.e7d3e35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/掌上智优_0.jpg
// module id = fLAn
// module chunks = 1